import { useContext } from "react";

import { ILayoutContext, LayoutContext } from "./LayoutContext";

export function useLayout(): ILayoutContext {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("useLayout must be used within a LayoutProvider");
  }

  return context;
}
